export default {
  dbi_trendinggames_title: '游戏推荐',
  dbi_trendinggames_related_links: '相关链接',
  dbi_trendinggames_left_1: '游戏简介',
  dbi_trendinggames_left_2: '商店排名',
  dbi_trendinggames_left_3: '关键指标',
  dbi_trendinggames_right_1: '舆情数据',
  dbi_trendinggames_right_3: '游戏商店评论',
  dbi_trendinggames_right_2: '社媒评论',
  dbi_trendinggames_right_4: '游戏相关新闻'
}